// extracted by mini-css-extract-plugin
export default {"title":"Header_title__0ndtx","subTitleBlock":"Header_subTitleBlock__ec5uL","subTitle":"Header_subTitle__0dugK","images":"Header_images__oH23z"};